import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import tracker from './usageTracker';
import { featureForPath, subFeatureForLocation } from './featureMap';

// Mount once in the authenticated app shell: starts the tracker and keeps the current
// feature in sync with the route. No identity read here (backend stamps it from the JWT).
export default function useUsageTracker() {
    const location = useLocation();

    useEffect(() => {
        tracker.start();
        return () => tracker.stop();
    }, []);

    useEffect(() => {
        // setFeature resets sub-feature; then apply the URL-derived one.
        tracker.setFeature(featureForPath(location.pathname));
        tracker.setSubFeature(subFeatureForLocation(location));
    }, [location]);
}
